import Address              from "../fundamentals/address/Address";
import Phone                from "../fundamentals/phone/Phone";
import CorporationApplicant from "./CorporationApplicant";
import CorporationId        from "./CorporationId";
import CorporationName      from "./CorporationName";
import CorporationNameKana  from "./CorporationNameKana";

class Corporation {
  constructor(
    private readonly _id: CorporationId = new CorporationId(),
    private readonly _name: CorporationName = new CorporationName(),
    private readonly _nameKana: CorporationNameKana = new CorporationNameKana(),
    private readonly _phone: Phone = new Phone(),
    private readonly _applicant: CorporationApplicant = new CorporationApplicant(),
    private readonly _address: Address = new Address(),
  ) {
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get nameKana() {
    return this._nameKana;
  }

  get phone() {
    return this._phone;
  }

  get applicant() {
    return this._applicant;
  }

  get address() {
    return this._address;
  }
}

export default Corporation;
